// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

import { OrderStatus, PossibleOrderStatus } from '../../../../contexts/orders/contracts/orders'

export interface OrderListItemConfig {
  variant: string
  theme: string
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const ORDER_LIST_ITEM_COMPONENT_CONFIG_MAP: OrderListItemConfig = {
  variant: 'outline',
  theme: ''
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const ORDER_LIST_ITEM_COMPONENT_KEY = 'OrderListItem'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export const statusIconsRegistry: Record<OrderStatus, AsyncComponent> = {
  [PossibleOrderStatus.Cancelled]: () => import(/* webpackChunkName: "orders/CanceledIcon" */ './partials/CanceledIcon.vue'),
  [PossibleOrderStatus.Closed]: () => import(/* webpackChunkName: "orders/CanceledIcon" */ './partials/CanceledIcon.vue'),
  [PossibleOrderStatus.Declined]: () => import(/* webpackChunkName: "orders/CanceledIcon" */ './partials/CanceledIcon.vue'),
  [PossibleOrderStatus.Complete]: () => import(/* webpackChunkName: "orders/CompleteIcon" */ './partials/CompleteIcon.vue'),
  [PossibleOrderStatus.Completed]: () => import(/* webpackChunkName: "orders/CompleteIcon" */ './partials/CompleteIcon.vue'),
  [PossibleOrderStatus.Processing]: () => import(/* webpackChunkName: "orders/ProcessingIcon" */ './partials/ProcessingIcon.vue'),
  [PossibleOrderStatus.Pending]: () => import(/* webpackChunkName: "orders/ProcessingIcon" */ './partials/ProcessingIcon.vue'),
  [PossibleOrderStatus['Payment Review']]: () => import(/* webpackChunkName: "orders/ProcessingIcon" */ './partials/ProcessingIcon.vue'),
  [PossibleOrderStatus['On hold']]: () => import(/* webpackChunkName: "orders/ProcessingIcon" */ './partials/ProcessingIcon.vue')
}
